import React from 'react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function HeroSection() {
  return <section className="relative bg-[#FFF8F0] pt-12 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-54">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-[#C9A84C] opacity-5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-55" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#0D5C63] opacity-5 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-56" />

      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-57">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="order-2 lg:order-1 text-center lg:text-left" data-id="element-58">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#0D5C63] leading-tight mb-6 font-serif" data-id="element-59">
            Panza Plana Posparto en 21 Días
          </h1>

          <h2 className="text-xl md:text-2xl text-[#2D2D2D] mb-8 font-medium leading-relaxed" data-id="element-60">
            12 minutos diarios entre niños y trabajo — sin gym, resultados
            reales para mamás latinas USA
          </h2>

          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-61">
            <Button className="text-lg px-10" onClick={() => {
            trackAddToCart();
            window.open('https://coreeveryday.com/cart/48302469382363:1', '_blank');
          }} data-id="element-62">
              COMPRAR AHORA POR $6.36 <ArrowRight className="ml-2 h-5 w-5" data-id="element-63" />
            </Button>
          </div>

          <p className="mt-4 text-sm text-gray-500 italic" data-id="element-64">
            Descarga instantánea • Acceso de por vida
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="order-1 lg:order-2 relative" data-id="element-65">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-66">
            <img src="https://cdn.magicpatterns.com/uploads/sJytikmtUXa8AakZYybUoy/heylloyd-image-1772036867616.png" alt="Panza Plana Posparto en 21 Días eBook en tablet y móvil" className="w-full h-auto object-cover" data-id="element-67" />
          </div>
          {/* Floating badge */}
          <div className="absolute -bottom-6 -left-6 bg-[#0D5C63] text-white p-4 rounded-full shadow-lg w-32 h-32 flex items-center justify-center text-center border-4 border-[#FFF8F0] hidden md:flex" data-id="element-68">
            <span className="font-bold font-serif text-lg leading-tight" data-id="element-69">
              Resultados
              <br data-id="element-70" />
              en 21 Días
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}